exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-family: 'Oleo Script Swash Caps', cursive;\n  color: #eae8e8;\n  margin-top: 20px;\n  font-size: 60px;\n}\n\np {\n  color: #eae8e8;\n}\n\napp-save-beat {\n  display: inline-block;\n}\n\n@media screen and (max-width: 580px) {\n  h1 {\n    font-size: 40px;\n  }\n}\n\n@media screen and (max-width: 375px) {\n  h1 {\n    font-size: 22px;\n  }\n\n  p {\n    font-size: 12px;\n    width: 300px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main